import { Component } from '@angular/core';
import { FilterPanelComponent } from './../../shared/shared-filter/filter-panel.component';

@Component({
  selector: `app-shared-filter`,
  templateUrl: `./shared-filter.component.html`,
  styleUrls: [`./shared-filter.component.scss`]
})
export class SharedFilterComponent {
  identifierCollapse: false;
}
